import { useRef } from 'react';
import { useQuery } from '@tanstack/react-query';

import { getTimeSeriesPeriodMap } from '@/utilities/timeSeriesPeriodMap';
import type { Period } from '@/utilities/timeSeriesPeriodMap';

import queryFn, { getDefault, Outcome } from './queryFn';

export const usePriceHistoryData = (companyId: string, period: Period) => {
  const { current: dateISOString } = useRef(new Date().toISOString());
  const today = dateISOString.substring(0, dateISOString.indexOf('T'));

  const { current: periodMap } = useRef(
    getTimeSeriesPeriodMap(new Date(today))
  );

  const { data = getDefault(), status } = useQuery({
    queryKey: ['price-history', companyId, periodMap[period], periodMap.NOW],
    queryFn,
    enabled: typeof companyId === 'string' && companyId !== '',
    staleTime: Infinity,
    retry: 1,
    refetchOnMount: false,
    notifyOnChangeProps: ['data', 'error'],
  });

  const isNegativeMovement = data?.movement === Outcome.NEGATIVE;

  return { data, periodMap, isNegativeMovement, status };
};
